import { PhosphorLock, PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";
import { mapAppointmentDateTimeToShowDates } from "shared/utils/fieldsHelper/showFields";
import { formatShowTimeLabel } from "shared/utils/purpleHeaderUtils";
import { getShowDateTimeDisplay, getShowTime } from "shared/utils/showDateTimeDisplay";
import { inTheNightOfDayName } from "shared/utils/showDateUtils";
import { showDateTimeStringsFromResx } from "utilities/momentutils";
import { PurpleHeaderCard, PurpleHeaderDivider, PurpleHeaderVerticalDivider } from "./PurpleHeaderCard";
import { PurpleHeaderPeopleRow } from "./PurpleHeaderPeopleRow";
import { usePurpleHeaderLayout } from "./usePurpleHeaderLayout";

interface EventHeaderLayoutProps {
  icon?: JSX.Element
  tourName: string | undefined
  title: string
  subtitle: string | undefined
  location: string | undefined
  dateTime: server.dto.AppointmentDateTime
  attendees: string[]
  artistName: string | undefined
  locked?: boolean
  notValidated?: boolean
  href?: string
  rightColumn?: JSX.Element
}

export const EventHeaderLayout = ({ icon, tourName, title, subtitle, location, dateTime, attendees, artistName, locked, notValidated, href, rightColumn }: EventHeaderLayoutProps) => {
  const layout = usePurpleHeaderLayout();
  const showDates = mapAppointmentDateTimeToShowDates(dateTime);
  const display = getShowDateTimeDisplay(showDates, showDateTimeStringsFromResx(), true);
  const timeLabel = formatShowTimeLabel(getShowTime(showDates));

  const info = <>
    {tourName && <div className="purple-header-text purple-header-light">{tourName}</div>}
    <div className="purple-header-title purple-header-clamp">{title}</div>
    {subtitle && <div className="purple-header-subtitle">{subtitle}</div>}
    {location && <div className="purple-header-text purple-header-light">{location}</div>}
  </>;

  const dateBlock = <>
    {display.inTheNightOfText && <div className="purple-header-text">{RESX.DateTime.InTheNightOf} {inTheNightOfDayName(showDates.startDisplayDate)}</div>}
    <div className="purple-header-subtitle">{display.dateText}</div>
    {timeLabel && <div className="purple-header-text">{timeLabel}</div>}
  </>;

  const peopleRow = <PurpleHeaderPeopleRow
    artistName={artistName}
    contactNames={attendees}
    locked={layout === "short" && locked}
    notValidated={layout === "short" && notValidated}
  />;

  if (layout === "short") {
    return <PurpleHeaderCard href={href}>
      <div className="purple-header-row">
        <div className="purple-header-info">
          {info}
          <div className="purple-header-date-block">{dateBlock}</div>
        </div>
        {rightColumn ?? icon}
      </div>
      <PurpleHeaderDivider />
      {peopleRow}
    </PurpleHeaderCard>;
  }

  return <PurpleHeaderCard wide href={href}>
    <div className="purple-header-wide-main">
      <div className="purple-header-info">{info}</div>
      {peopleRow}
    </div>
    <PurpleHeaderVerticalDivider />
    <div className="purple-header-wide-date">{dateBlock}</div>
    {(rightColumn || icon) && <>
      <PurpleHeaderVerticalDivider />
      {rightColumn ?? <div className="purple-header-wide-icons">
        {icon}
        {locked && <PhosphorLock iconColor="white" iconSize="large" />}
        {notValidated && <PhosphorWarning iconColor="white" iconSize="large" />}
      </div>}
    </>}
  </PurpleHeaderCard>;
};
